import styled from '@emotion/styled'
import { Button, Image as AntdImage } from 'antd'

export const Container = styled('div')`
  justify-content: center;
  height: 111px;
  width: 80px;
`

export const ButtonRemove = styled(Button)`
  position: absolute;
  top: 5px;
  right: 5px;

  border: none;
  width: 15px !important;
  height: 15px !important;
  min-width: 15px !important;

  padding: 0 !important;
  margin: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  background: rgba(0, 0, 0, 0.8);
  color: #ffffff;
  z-index: 1;
`

export const IconSvg = styled('img')`
  width: 6px;
  height: 6px;
  object-fit: contain;
`

export const ContainerImage = styled('div')`
  border-radius: 8px;
  border: 1px solid #e5e5e5;
  overflow: hidden;
  position: relative;
  height: 80px;
  width: 80px;

  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    border: 1px solid #009640;
    box-shadow: 0 0 0 2px #c3e9cc;
  }
`

export const Image = styled('img')`
  height: 100%;
  object-fit: contain;
  display: block;
`

export const PdfIcon = styled('img')`
  width: 32px;
  height: 32px;
  object-fit: contain;
  display: block;
  cursor: pointer;
`

export const ImagePreviewGroupFilename = styled('div')<{ isShow: boolean }>`
  top: 0;
  left: 9px;
  padding-top: 14px;
  padding-left: 5px;
  position: fixed;
  display: ${(props) => (props.isShow ? 'block' : 'none')};
  z-index: 9999;
  color: #fff;
`

export const ImagePreviewGroup = styled('div')`
  display: none;
`

export const ImagePreviewGroupContainer = styled(AntdImage.PreviewGroup)``

export const ImagePreviewGroupFooter = styled('div')<{ isShow: boolean }>`
  bottom: 0;
  right: 15px;
  padding-bottom: 10px;
  position: fixed;
  display: ${(props) => (props.isShow ? 'block' : 'none')};
  z-index: 9999;
`

export const ImagePreviewItem = styled(AntdImage)``

export const DownloadIcon = styled('img')`
  height: 21px;
  width: 21px;
  cursor: pointer;
`

export const TrashIcon = styled('img')`
  height: 21px;
  width: 21px;
  cursor: pointer;
`
